/*
 * Texte für /login und /register.
 *
 * Wie publicPages.js: CommonJS, nur Daten, keine Imports – wird auch von
 * scripts/export-texts.js gelesen (npm run texte).
 * Die Aufzählung links auf /register kommt aus publicPages.landing.audiences.
 */

const types = {
  user: { label: 'Schütze', icon: 'mdi-target-account' },
  club: { label: 'Verein', icon: 'mdi-home-group' }
};

const login = {
  kicker: 'Für Schützen und Vereine',
  title: 'Anmelden',
  text:
    'Schützen melden sich mit ihrer eigenen E-Mail-Adresse an, Vereine mit der Adresse des Vereinskontos. Im Formular wählst du aus, welches Konto du öffnen willst.',
  cardTitle: 'Bei schuetzenbuch.de anmelden',
  fields: {
    email: 'E-Mail-Adresse',
    password: 'Passwort'
  },
  required: {
    email: 'Bitte gib deine E-Mail-Adresse ein.',
    password: 'Bitte gib dein Passwort ein.'
  },
  submit: 'Anmelden',
  submitting: 'Wird angemeldet …',
  forgot: 'Passwort vergessen?',
  switch: { text: 'Noch kein Konto?', link: 'Jetzt registrieren', to: '/register' }
};

const register = {
  kicker: 'Neues Konto',
  title: 'Registrieren',
  text:
    'Die Registrierung dauert nur ein paar Minuten. Danach bekommst du eine E-Mail, mit der du deine Adresse bestätigst.',
  cardTitle: 'Konto anlegen',
  fields: {
    email: 'E-Mail-Adresse',
    clubEmail: 'E-Mail-Adresse des Vereins',
    vorname: 'Vorname',
    name: 'Nachname',
    clubName: 'Vereinsname',
    mitgliedsnr: 'Mitgliedsnummer (optional)',
    mitgliedsnrHint: 'Kannst du auch später im Profil eintragen.',
    vereinsnr: 'Vereinsnummer',
    vereinsnrHint: 'Die Nummer, unter der dein Verein beim Verband geführt wird.',
    password: 'Passwort',
    password2: 'Passwort wiederholen'
  },
  required: {
    email: 'Bitte gib eine E-Mail-Adresse ein.',
    vorname: 'Bitte gib deinen Vornamen ein.',
    name: 'Bitte gib deinen Nachnamen ein.',
    clubName: 'Bitte gib den Namen des Vereins ein.',
    vereinsnr: 'Bitte gib die Vereinsnummer ein.',
    password: 'Bitte wähle ein Passwort.'
  },
  emailFormat: 'Das sieht nicht nach einer gültigen E-Mail-Adresse aus.',
  // Gleiche Regeln wie im Backend (Password::defaults in AppServiceProvider)
  passwordRules: {
    title: 'Dein Passwort braucht:',
    length: 'mindestens 10 Zeichen',
    mixedCase: 'Groß- und Kleinbuchstaben',
    number: 'mindestens eine Zahl',
    symbol: 'mindestens ein Sonderzeichen',
    notMet: 'Das Passwort erfüllt noch nicht alle Anforderungen.'
  },
  passwordMismatch: 'Die Passwörter stimmen nicht überein.',
  captchaMissing: 'Bitte löse noch das Captcha.',
  captchaFailed: 'Die Captcha-Prüfung hat nicht geklappt. Bitte löse das Captcha noch einmal.',
  formError: 'Bitte prüfe die markierten Felder. Deine Eingaben sind noch da, du musst nur das Captcha noch einmal lösen.',
  // Alles außer Validierung und Captcha, z. B. 500 beim Versand der Bestätigungs-E-Mail
  serverError: mail =>
    `Beim Anlegen des Kontos ist bei uns etwas schiefgegangen. Bitte versuch es später noch einmal. Klappt es dann immer noch nicht, schreib uns an ${mail}.`,
  submit: 'Konto anlegen',
  submitting: 'Wird angelegt …',
  privacy: { text: 'Welche Daten wir speichern, steht in der', link: 'Datenschutzerklärung', to: '/datenschutz' },
  switch: { text: 'Schon registriert?', link: 'Zur Anmeldung', to: '/login' },
  success: {
    title: 'Fast geschafft',
    text: email =>
      `Wir haben eine E-Mail an ${email} geschickt. Klick auf den Link darin, damit ist die Adresse bestätigt und du kannst dich anmelden.`,
    spam: 'Keine E-Mail da? Schau auch im Spam-Ordner nach.',
    button: 'Zur Anmeldung'
  }
};

module.exports = { types, login, register };
